var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpListDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.66663C16.6604 3.67772 17.7402 3.76614 18.4445 4.47049C19.25 5.27595 19.25 6.57231 19.25 9.16503V14.665C19.25 17.2578 19.25 18.5541 18.4445 19.3596C17.6391 20.165 16.3427 20.165 13.75 20.165H8.25C5.65728 20.165 4.36091 20.165 3.55546 19.3596C2.75 18.5541 2.75 17.2578 2.75 14.665V9.16503C2.75 6.57231 2.75 5.27595 3.55546 4.47049C4.25981 3.76614 5.33956 3.67772 7.33333 3.66663",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.2834L9.82143 13.75L13.75 10.0834",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 3.20837C7.33325 2.44898 7.94886 1.83337 8.70825 1.83337H13.2916C14.051 1.83337 14.6666 2.44898 14.6666 3.20837V4.12504C14.6666 4.88443 14.051 5.50004 13.2916 5.50004H8.70825C7.94886 5.50004 7.33325 4.88443 7.33325 4.12504V3.20837Z",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpListDark);
export default __webpack_public_path__ + "static/media/emp-list-dark.c65ff32bdc896f16d97700caea82eb23.svg";
export { ForwardRef as ReactComponent };